export const calculatorRoutes = [
  // All PDF
  {
  path: "/",
  component: "Home",
  title: "Free PDF Tools - Merge, Split, Compress & Convert PDFs | QuickPDFs.net",
  description: "Use QuickPDFs.net's free PDF tools to merge, split, compress, and convert PDF documents. Easy-to-use online solutions for all your PDF needs. No registration required.",
  keywords: "free PDF tools, merge PDF, split PDF, compress PDF, PDF converter, online PDF tools, PDF merger, PDF splitter, PDF compressor, document converter"
},

{
  path: "/PDFTools",
  component: "PDFTools",
  title: "All PDF Tools - Merge, Split, Compress & Convert PDFs | QuickPDFs.net",
  description: "Access all free PDF tools at QuickPDFs.net. Merge, split, compress, convert, and edit PDF documents online. Complete collection of PDF utilities for all your document needs.",
  keywords: "all PDF tools, PDF tools collection, merge PDF, split PDF, compress PDF, PDF converter, edit PDF, PDF utilities, online PDF tools, free PDF tools, document tools"
},

{
  path: "/PDFMerger",
  component: "PDFMerger",
  title: "Merge PDF Files Online Free | Combine PDFs | QuickPDFs.net",
  description: "Merge multiple PDF files into one document quickly and easily with QuickPDFs.net. Free online PDF merger with secure and fast processing. No file size limits.",
  keywords: "merge pdf, combine pdf files, pdf merger online, join pdf files, free pdf merge tool, combine pdf documents, pdf joiner"
},

{
  path: "/PDFSplit",
  component: "PDFSplit",
  title: "Split PDF Files Online Free | Separate PDF Pages | QuickPDFs.net",
  description: "Split PDF files into multiple documents quickly and easily with QuickPDFs.net. Free online PDF splitter to extract pages or divide PDFs. Secure and fast processing.",
  keywords: "split pdf, separate pdf pages, pdf splitter online, extract pdf pages, divide pdf document, free pdf split tool, pdf page remover"
},

{
  path: "/PDFExtractPages",
  component: "PDFExtractPages",
  title: "Extract PDF Pages Online Free | PDF Page Extractor | QuickPDFs.net",
  description: "Extract specific pages from PDF files quickly and easily with QuickPDFs.net. Free online PDF page extractor to create new PDFs from selected pages. Secure processing.",
  keywords: "extract pdf pages, pdf page extractor, extract pages from pdf, pdf page remover, select pdf pages, free pdf extraction tool, pdf page selector"
},

{
  path: "/PDFOrganizer",
  component: "PDFOrganizer",
  title: "Organize PDF Pages Online Free | Rearrange PDF | QuickPDFs.net",
  description: "Organize and rearrange pages in your PDF documents with QuickPDFs.net. Free online PDF organizer to reorder, rotate, and manage pages. Simple and secure.",
  keywords: "organize pdf, rearrange pdf pages, pdf page organizer, reorder pdf pages, rotate pdf pages, pdf page manager, free pdf organizer"
},

{
  path: "/PDFDeletePages",
  component: "PDFDeletePages",
  title: "Delete Pages from PDF Online Free | Remove PDF Pages | QuickPDFs.net",
  description: "Delete unwanted pages from your PDF documents quickly with QuickPDFs.net. Free online tool to remove specific pages from PDF files. Secure and easy to use.",
  keywords: "delete pdf pages, remove pages from pdf, pdf page remover, delete pages from pdf online, pdf page deletion tool, free pdf page remover"
},

{
  path: "/PDFCompress",
  component: "PDFCompress",
  title: "Compress PDF Files Online Free | Reduce PDF Size | QuickPDFs.net",
  description: "Compress PDF files to reduce file size while maintaining quality with QuickPDFs.net. Free online PDF compressor for smaller, shareable documents. Fast and secure.",
  keywords: "compress pdf, reduce pdf size, pdf compressor online, shrink pdf file, optimize pdf, free pdf compression, pdf size reducer"
},

{
  path: "/PDFRepair",
  component: "PDFRepair",
  title: "Repair PDF Files Online Free | Fix Corrupted PDF | QuickPDFs.net",
  description: "Repair corrupted or damaged PDF files quickly with QuickPDFs.net. Free online PDF repair tool to fix and recover your important documents. Secure processing.",
  keywords: "repair pdf, fix corrupted pdf, pdf repair tool, recover pdf file, fix damaged pdf, pdf recovery, free pdf repair online"
},

{
  path: "/PDFOCR",
  component: "PDFOCR",
  title: "OCR PDF Online Free | Convert Scanned PDF to Text | QuickPDFs.net",
  description: "Convert scanned PDF documents into searchable and editable text with QuickPDFs.net. Free online OCR tool for PDFs. Extract text from images and scanned files accurately.",
  keywords: "pdf ocr, ocr pdf online, scanned pdf to text, pdf text extractor, ocr scanner, convert scanned pdf to editable text, free pdf ocr tool, image to text"
},

{
  path: "/PDFFlatten",
  component: "PDFFlatten",
  title: "Flatten PDF Online Free | Make PDF Non-Editable | QuickPDFs.net",
  description: "Flatten your PDF files to combine all layers into a single layer with QuickPDFs.net. Free online tool to make PDFs non-editable and secure for sharing.",
  keywords: "flatten pdf, pdf flattener online, make pdf read-only, flatten pdf layers, pdf flattening tool, secure pdf, free pdf flattener"
},

{
  path: "/PDFToWord",
  component: "PDFToWord",
  title: "Convert PDF to Word Online Free | PDF to DOCX | QuickPDFs.net",
  description: "Convert PDF files to editable Word documents (DOCX) with QuickPDFs.net. Free online PDF to Word converter with high accuracy and formatting preservation.",
  keywords: "pdf to word, convert pdf to docx, pdf to word converter, pdf to editable word, pdf to doc, free pdf to word tool, pdf converter"
},

{
  path: "/PDFToPowerPoint",
  component: "PDFToPowerPoint",
  title: "Convert PDF to PowerPoint Online Free | PDF to PPTX | QuickPDFs.net",
  description: "Convert PDF files to editable PowerPoint presentations (PPTX) with QuickPDFs.net. Free online PDF to PPT converter with high quality and formatting accuracy.",
  keywords: "pdf to powerpoint, pdf to ppt, pdf to pptx converter, convert pdf to presentation, pdf to slides, free pdf to ppt tool, presentation converter"
},

{
  path: "/PDFToExcel",
  component: "PDFToExcel",
  title: "Convert PDF to Excel Online Free | PDF to XLSX | QuickPDFs.net",
  description: "Convert PDF files to editable Excel spreadsheets (XLSX) with QuickPDFs.net. Free online PDF to Excel converter that extracts tables and data accurately.",
  keywords: "pdf to excel, convert pdf to xlsx, pdf to excel converter, extract pdf tables, pdf to spreadsheet, free pdf to excel tool, data extraction"
},

{
  path: "/WordToPDF",
  component: "WordToPDF",
  title: "Convert Word to PDF Online Free | DOCX to PDF | QuickPDFs.net",
  description: "Convert Word documents (DOCX) to PDF format with QuickPDFs.net. Free online Word to PDF converter with perfect formatting and easy sharing.",
  keywords: "word to pdf, convert docx to pdf, word to pdf converter, doc to pdf, microsoft word to pdf, free word to pdf tool, document converter"
},

{
  path: "/PowerPointToPDF",
  component: "PowerPointToPDF",
  title: "Convert PowerPoint to PDF Online Free | PPT to PDF | QuickPDFs.net",
  description: "Convert PowerPoint presentations (PPT/PPTX) to PDF format with QuickPDFs.net. Free online PPT to PDF converter that preserves slides and formatting.",
  keywords: "powerpoint to pdf, ppt to pdf, pptx to pdf, convert presentation to pdf, powerpoint to pdf converter, free ppt to pdf tool, slide converter"
},

{
  path: "/ExcelToPDF",
  component: "ExcelToPDF",
  title: "Convert Excel to PDF Online Free | XLSX to PDF | QuickPDFs.net",
  description: "Convert Excel spreadsheets (XLSX) to PDF format with QuickPDFs.net. Free online Excel to PDF converter that preserves tables, charts, and formatting.",
  keywords: "excel to pdf, convert xlsx to pdf, excel to pdf converter, xls to pdf, spreadsheet to pdf, free excel to pdf tool, table to pdf"
},

{
  path: "/PDFToJPG",
  component: "PDFToJPG",
  title: "Convert PDF to JPG Online Free | PDF to Image | QuickPDFs.net",
  description: "Convert PDF pages to high-quality JPG images with QuickPDFs.net. Free online PDF to JPG converter that extracts images from PDF documents. Fast and secure.",
  keywords: "pdf to jpg, convert pdf to image, pdf to jpg converter, pdf to png, extract images from pdf, pdf to picture, free pdf to image tool"
},

{
  path: "/JPGToPDF",
  component: "JPGToPDF",
  title: "Convert JPG to PDF Online Free | Image to PDF | QuickPDFs.net",
  description: "Convert JPG images to PDF documents with QuickPDFs.net. Free online JPG to PDF converter that creates PDFs from multiple images. Easy and secure.",
  keywords: "jpg to pdf, convert image to pdf, jpeg to pdf, png to pdf, image to pdf converter, pictures to pdf, free image to pdf tool"
},

{
  path: "/HTMLToPDF",
  component: "HTMLToPDF",
  title: "Convert HTML to PDF Online Free | Webpage to PDF | QuickPDFs.net",
  description: "Convert HTML files and webpages to PDF documents with QuickPDFs.net. Free online HTML to PDF converter that preserves formatting and layout.",
  keywords: "html to pdf, convert webpage to pdf, url to pdf, html to pdf converter, website to pdf, online webpage to pdf, free html to pdf tool"
},

{
  path: "/PDFToPDFA",
  component: "PDFToPDFA",
  title: "Convert PDF to PDF/A Online Free | Archive PDF | QuickPDFs.net",
  description: "Convert standard PDF files to PDF/A format for long-term archiving with QuickPDFs.net. Free online PDF to PDF/A converter that ensures document preservation.",
  keywords: "pdf to pdfa, convert to pdf/a, pdf archiving, pdf/a converter, long-term preservation, archive pdf, free pdf to pdfa tool, pdf standardization"
},

{
  path: "/JSONToPDF",
  component: "JSONToPDF",
  title: "Convert JSON to PDF Online Free | JSON to PDF Converter | QuickPDFs.net",
  description: "Convert JSON data to formatted PDF documents with QuickPDFs.net. Free online tool to transform JSON files into readable, printable PDFs with structured tables.",
  keywords: "json to pdf, convert json to pdf, json to pdf converter, json to pdf online, json formatter to pdf, json data to pdf, free json to pdf tool"
},

{
  path: "/PDFEdit",
  component: "PDFEdit",
  title: "Edit PDF Online Free | PDF Editor | QuickPDFs.net",
  description: "Edit PDF documents online with QuickPDFs.net. Free PDF editor to add text, images, annotations, and make changes to your PDF files. Simple and secure.",
  keywords: "edit pdf, pdf editor online, edit pdf files, modify pdf, add text to pdf, pdf annotation tool, free pdf editor, pdf editing tool"
},

{
  path: "/PDFAddWatermark",
  component: "PDFAddWatermark",
  title: "Add Watermark to PDF Online Free | PDF Watermarker | QuickPDFs.net",
  description: "Add text or image watermarks to your PDF documents with QuickPDFs.net. Free online tool to protect your PDFs with custom watermarks. Easy and secure.",
  keywords: "add watermark to pdf, pdf watermark, watermark pdf online, text watermark pdf, image watermark pdf, protect pdf with watermark, free pdf watermark tool"
},

{
  path: "/PDFRemoveWatermark",
  component: "PDFRemoveWatermark",
  title: "Remove Watermark from PDF Online Free | PDF Cleaner | QuickPDFs.net",
  description: "Remove unwanted watermarks from PDF documents with QuickPDFs.net. Free online tool to clean your PDF files by removing text and image watermarks.",
  keywords: "remove watermark from pdf, delete pdf watermark, pdf watermark remover, clean pdf, remove text from pdf, clear pdf watermark, free pdf cleaner"
},

{
  path: "/PDFSign",
  component: "PDFSign",
  title: "Sign PDF Online Free | Add Signature to PDF | QuickPDFs.net",
  description: "Add digital signatures to your PDF documents with QuickPDFs.net. Free online tool to create and insert signatures, initials, and sign PDFs securely.",
  keywords: "sign pdf, pdf signature, add signature to pdf, digital signature pdf, electronic signature, sign document online, free pdf signer, esign pdf"
},

{
  path: "/PDFRotate",
  component: "PDFRotate",
  title: "Rotate PDF Pages Online Free | PDF Rotator | QuickPDFs.net",
  description: "Rotate PDF pages permanently with QuickPDFs.net. Free online tool to rotate single or multiple pages in your PDF document. Easy and secure.",
  keywords: "rotate pdf, pdf rotator, rotate pdf pages, pdf page orientation, rotate pdf online, pdf rotation tool, free pdf rotator"
},

{
  path: "/AddPDFPageNumber",
  component: "AddPDFPageNumber",
  title: "Add Page Numbers to PDF Online Free | PDF Numbering | QuickPDFs.net",
  description: "Add custom page numbers to your PDF documents with QuickPDFs.net. Free online tool to insert page numbers in various formats and positions.",
  keywords: "add page numbers to pdf, pdf page numbering, insert page numbers, pdf page numbers, number pdf pages, pdf numbering tool, free pdf page numberer"
},

{
  path: "/PDFCrop",
  component: "PDFCrop",
  title: "Crop PDF Pages Online Free | PDF Cropper | QuickPDFs.net",
  description: "Crop PDF pages to remove unwanted margins and areas with QuickPDFs.net. Free online tool to trim and resize PDF pages precisely.",
  keywords: "crop pdf, pdf cropper, crop pdf pages, trim pdf, cut pdf margins, resize pdf pages, free pdf cropping tool"
},

{
  path: "/PDFUnlock",
  component: "PDFUnlock",
  title: "Unlock PDF Online Free | Remove PDF Password | QuickPDFs.net",
  description: "Remove password protection from secured PDF files with QuickPDFs.net. Free online tool to unlock PDFs for editing, printing, and copying.",
  keywords: "unlock pdf, remove pdf password, pdf password remover, unlock protected pdf, pdf unlocker, remove pdf security, free pdf unlock tool"
},

{
  path: "/PDFProtect",
  component: "PDFProtect",
  title: "Protect PDF with Password Online Free | PDF Security | QuickPDFs.net",
  description: "Add password protection to your PDF documents with QuickPDFs.net. Free online tool to secure PDFs with user and owner passwords. Encrypt and protect.",
  keywords: "protect pdf, password protect pdf, pdf security, encrypt pdf, lock pdf with password, pdf protection tool, secure pdf online, free pdf encryptor"
},

{
  path: "/PDFCompare",
  component: "PDFCompare",
  title: "Compare PDF Files Online Free | PDF Difference Checker | QuickPDFs.net",
  description: "Compare two PDF files to find differences with QuickPDFs.net. Free online tool to highlight changes, additions, and deletions between PDF documents.",
  keywords: "compare pdf, pdf comparison, pdf diff, compare pdf files, pdf difference checker, pdf comparison tool, find pdf changes, free pdf comparer"
},

{
  path: "/PDFRedact",
  component: "PDFRedact",
  title: "Redact PDF Online Free | Remove Sensitive Information | QuickPDFs.net",
  description: "Redact sensitive information from PDF documents with QuickPDFs.net. Free online tool to permanently remove and black out text, images, and metadata.",
  keywords: "redact pdf, pdf redaction, black out text pdf, remove sensitive data pdf, pdf sanitizer, redact information pdf, free pdf redaction tool"
},

{
  path: "/PDFSummary",
  component: "PDFSummary",
  title: "Generate PDF Summary Online Free | PDF Information | QuickPDFs.net",
  description: "Create detailed summaries and extract metadata from PDF documents with QuickPDFs.net. Free online tool to analyze PDF properties, pages, and statistics.",
  keywords: "pdf summary, pdf information, pdf metadata, analyze pdf, pdf statistics, pdf properties, pdf document info, free pdf analyzer"
},

{
  path: "/PDFTranslate",
  component: "PDFTranslate",
  title: "Translate PDF Online Free | PDF Language Translator | QuickPDFs.net",
  description: "Translate your PDF documents into multiple languages with QuickPDFs.net. Free online tool to convert PDF text while preserving layout and formatting.",
  keywords: "translate pdf, pdf translator, translate pdf document, pdf language converter, translate pdf online, multilingual pdf, free pdf translation tool"
}

];

// Helper function to get route by path
export const getRouteByPath = (path) => {
  return calculatorRoutes.find(route => route.path === path);
};

// Helper function to get all paths
export const getAllPaths = () => {
  return calculatorRoutes.map(route => route.path);
};